import React from 'react';
import {
  Upload, FileText, CheckCircle,
  XCircle, ShieldCheck, AlertTriangle,
  X, Eye
} from 'lucide-react';

const KYCUploadSection = ({
  kycStatus,
  rejectNote,
  kycFile,
  kycPreview,
  submitNote,
  setSubmitNote,
  loading,
  handleKycFile,
  removeKycFile,
  handleSubmit,
}) => {
  const hasAnyFile = !!kycFile;

  return (
    <div className="kyc-center-block">

      {/* Rejected notice */}
      {kycStatus === 'rejected' && (
        <div className="kyc-rejected-notice">
          <XCircle size={16}/>
          <span>{rejectNote || 'Aapki documents reject ho gayi hain. Sahi documents dobara upload karein.'}</span>
        </div>
      )}

      <div className="kyc-section-title">
        <FileText size={16}/> Required Documents
      </div>

      <div className="kyc-doc-card">
        <div className="kyc-doc-card__top">
          <div className="kyc-doc-card__info">
            <span className="kyc-doc-card__label">KYC Documents — Single PDF</span>
            <div className="kyc-doc-card__desc-list">

              <div className="kyc-check-item">
                <CheckCircle size={16} className="kyc-check-icon" />
                <span>CNIC (Front & Back)</span>
              </div>

              <div className="kyc-check-item">
                <CheckCircle size={16} className="kyc-check-icon" />
                <span>Address Proof (Bill / Utility)</span>
              </div>

              <div className="kyc-check-item">
                <CheckCircle size={16} className="kyc-check-icon" />
                <span>Educational / Skill Certificate</span>
              </div>

              <div className="kyc-check-item">
                <CheckCircle size={16} className="kyc-check-icon" />
                <span>Selfie with ID Card</span>
              </div>

            </div>
          </div>
          {kycFile && <span className="kyc-doc-card__done"><CheckCircle size={16}/></span>}
        </div>

        {kycFile ? (
          <div className="kyc-file-preview">
            <div className="kyc-file-preview__name">
              <FileText size={14}/>
              <span>{kycFile.name}</span>
            </div>
            <div className="kyc-file-preview__actions">
              {kycPreview && (
                <a href={kycPreview} target="_blank" rel="noreferrer" className="kyc-preview-btn">
                  <Eye size={13}/> View
                </a>
              )}
              <button className="kyc-remove-btn" onClick={removeKycFile}>
                <X size={13}/> Remove
              </button>
            </div>
          </div>
        ) : (
          <label className="kyc-upload-area">
            <Upload size={20}/>
            <span>Upload PDF</span>
            <span className="kyc-upload-area__hint">PDF only · Max 10MB</span>
            <input
              type="file"
              accept=".pdf,application/pdf"
              style={{ display: 'none' }}
              onChange={handleKycFile}
            />
          </label>
        )}
      </div>

      {/* Note field */}
      <div className="kyc-note-field">
        <label>Additional Note (optional)</label>
        <textarea
          placeholder="Any additional information for the admin..."
          value={submitNote}
          onChange={e => setSubmitNote(e.target.value)}
          rows={3}
        />
      </div>

      {/* Submit button */}
      <button
        className="kyc-submit-btn"
        onClick={handleSubmit}
        disabled={!hasAnyFile || loading}
      >
        {loading
          ? <><div className="kyc-btn-spinner"/> Submitting...</>
          : <><ShieldCheck size={16}/> Submit for Verification</>
        }
      </button>

      {!hasAnyFile && (
        <p className="kyc-helper-note">
          <AlertTriangle size={13}/> Upload at least one document to submit.
        </p>
      )}
    </div>
  );
};

export default KYCUploadSection;